import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'

const StyledTabsRoot = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
`

const StyledTabsList = styled.div`
  flex-shrink: 0;
  display: flex;
  border-bottom: 1px solid ${colorsOptions.greys['grey-30']};

  &[data-loading] {
    border: none;
  }
`

const StyledTabsTrigger = styled.button`
  all: unset;
  outline: none;

  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}

  background-color: white;
  padding: 0 1.875rem;
  height: 40px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colorsOptions.greys['grey-100']};
  stroke: ${colorsOptions.greys['grey-100']};
  user-select: none;
  border: 0.5px solid ${colorsOptions.greys['grey-30']};

  &:first-child {
    border-top-left-radius: 16px;
  }

  &:last-child {
    border-top-right-radius: 16px;
  }

  &:hover {
    background-color: ${colorsOptions.greys['grey-10']};
  }

  &:focus {
    background-color: ${colorsOptions.greys['grey-20']};
    border-color: ${colorsOptions.greys['grey-30']};
  }

  &:disabled {
    background-color: ${colorsOptions.greys.white};
    border-color: ${colorsOptions.greys['grey-30']};
    color: ${colorsOptions.greys['grey-40']};
  }

  &[data-loading] {
    background-color: ${colorsOptions.greys['grey-10']};
    border: none;
    box-shadow: none;
  }

  &[data-state='active'] {
    color: ${colorsOptions.docuToolsOrange.orange};
    stroke: ${colorsOptions.docuToolsOrange.orange};
    background-color: ${colorsOptions.docuToolsOrange['dt-10']};
    box-shadow:
      inset 0 -1px 0 0 currentColor,
      0 1px 0 0 currentColor;
    border-color: ${colorsOptions.docuToolsOrange.orange};
    &:hover {
      color: ${colorsOptions.docuToolsOrange['dt-50']};
      stroke: ${colorsOptions.docuToolsOrange['dt-50']};
      border-color: ${colorsOptions.docuToolsOrange['dt-50']};
    }
    &:active {
      background-color: ${colorsOptions.docuToolsOrange['dt-20']};
      border-color: ${colorsOptions.docuToolsOrange['dt-50']};
      color: ${colorsOptions.docuToolsOrange['dt-50']};
      stroke: ${colorsOptions.docuToolsOrange['dt-50']};
    }
    &:disabled {
      background-color: ${colorsOptions.greys['grey-10']};
      border-color: ${colorsOptions.greys['grey-50']};
      color: ${colorsOptions.greys['grey-40']};
    }
    &[data-loading] {
      background-color: ${colorsOptions.docuToolsOrange['dt-10']};
      border: none;
      box-shadow: none;
    }
  }
`

const StyledTabsContent = styled.div`
  all: unset;
  flex-grow: 1;
  padding: 1rem;
  background-color: white;
  outline: none;
`

const StyledTabsSkeleton = styled.div`
  background-color: ${colorsOptions.greys['grey-30']};
  color: ${colorsOptions.greys['grey-30']};
  border-radius: 48px;
`

export {
  StyledTabsContent,
  StyledTabsList,
  StyledTabsRoot,
  StyledTabsTrigger,
  StyledTabsSkeleton
}
